<!-- REGULAR NAV -->

<nav class="navbar navbar-expand-lg navbar-light fixed-top">
  <div class="d-flex">
    <div>
      <a class="navbar-brand" href="javascript:void(0)">
        <img [routerLink]="['']" alt="" src="/assets/logo.png" />
      </a>

      <span class="strong">
        {{ user?.firstName | personName : user?.lastName }}
      </span>
    </div>

    <div
      class="atelier-navbar-text d-flex ml-4 mt-auto mb-auto"
      *ngIf="!overview"
    >
      <div class="d-flex strong click-link" (click)="backPressed()">
        <mat-icon class="back-icon">keyboard_arrow_left</mat-icon>

        <span>Terug</span>
      </div>

      <div class="strong atelier-navbar-details-text">Project</div>
    </div>
  </div>

  <div class="atelier-navbar-text d-flex">
    <div
      class="clickable"
      [ngClass]="{ 'view-active': activeView === ASSIGNMENTS_VIEW }"
      (click)="openAssignments()"
    >
      Opdrachten
    </div>
    &nbsp;/&nbsp;
    <div
      class="clickable"
      [ngClass]="{ 'view-active': activeView === CONTROL_VIEW }"
      (click)="openControle()"
    >
      Controle
    </div>
    &nbsp;/&nbsp;
    <div
      class="clickable"
      [ngClass]="{ 'view-active': activeView === RECOVERY_VIEW }"
      (click)="openRecovery()"
    >
      Recupborden
    </div>
  </div>

  <div class="menubtns">
    <mat-icon
      matTooltip="U heeft een internetverbinding"
      *ngIf="connectedToBackend"
      class="connected-icon green-connected-icon"
    >
      signal_cellular_4_bar
    </mat-icon>

    <mat-icon
      matTooltip="U heeft geen internetverbinding"
      *ngIf="!connectedToBackend"
      class="connected-icon red-connected-icon"
    >
      signal_cellular_off
    </mat-icon>

    <div *ngIf="loadingService.showLoader" class="right-space">
      <mat-icon *ngIf="loadingService.saved" svgIcon="check"></mat-icon>

      <mat-icon *ngIf="loadingService.error" class="error-icon" color="primary">
        error
      </mat-icon>

      <mat-spinner
        *ngIf="loadingService.saving"
        color="primary"
        diameter="24"
      ></mat-spinner>
    </div>

    <div *ngIf="overview" class="date-picker">
      <div class="d-flex">
        <mat-icon
          class="clickable date-picker-arrow date-picker-arrow-left"
          (click)="changeDay(-1)"
        >
          keyboard_arrow_left
        </mat-icon>

        <mat-datepicker-toggle class="no-ripple" matPrefix [for]="picker">
          <mat-icon
            class="align-calendar-icon calendar-icon-display"
            matDatepickerToggleIcon
            svgIcon="inpress-calendar"
          ></mat-icon>
        </mat-datepicker-toggle>

        <input
          class="date-picker-input"
          matInput
          [readonly]="true"
          [matDatepicker]="picker"
          [ngModel]="date"
          (ngModelChange)="dateChange($event)"
        />

        <mat-datepicker #picker></mat-datepicker>

        <mat-icon
          class="clickable date-picker-arrow date-picker-arrow-right"
          (click)="changeDay(1)"
        >
          keyboard_arrow_right
        </mat-icon>
      </div>
    </div>

    <mat-divider class="after-date-content" vertical="true"></mat-divider>

    <div *ngIf="isTestEnvironment()" class="test-environment-text-align">
      <span class="test-environment-text">TESTOMGEVING</span>
    </div>

    <span class="after-date-content" *ngIf="this.user">
      <div
        class="user"
        [matMenuTriggerFor]="accountMenu"
        matTooltip="{{ user?.firstName }} {{ user?.lastName }}"
      >
        <div class="rounded-circle employee-initials">
          <span
            *ngIf="!this.user.profilePicture"
            class="employee-initials rounded-circle in-the-middle no-margin"
          >
            {{ getLettres() }}
          </span>

          <span
            *ngIf="this.user.profilePicture"
            class="in-the-middle rounded-circle"
          >
            <img
              class="rounded-circle"
              *ngIf="isImage(user.profilePicture)"
              width="30px"
              height="30px"
              src="/api/assets/{{ user.profilePicture.uuid }}"
            />
          </span>
        </div>
      </div>

      <mat-menu class="menu" #accountMenu="matMenu" yPosition="below">
        <button mat-menu-item (click)="returnToAdmin()" *ngIf="isAdmin()">
          Terug naar adminportaal
        </button>

        <button
          mat-menu-item
          (click)="stopImpersonate()"
          *ngIf="isImpersonating()"
        >
          Stop nabootsing
        </button>

        <button mat-menu-item (click)="logout()">Log out</button>
      </mat-menu>
    </span>
  </div>
</nav>
